import { FC } from 'react'
import { SecuritiesLawTransactionData } from "src/dtos/applicationData"
import { 
  FlexDiv, 
  ClaimItemFormMainContainer,
  ClaimItemFormSection,
  ClaimItemTitle, 
  FormInputTitle,
} from './styles'
import { LeftBar } from '../../basic/LeftBar'
import StandardInput from '../../basic/StandardInput'
import StepBullet from '../../basic/StepBullet'
import StandardFormatInput from '../../../components/basic/StandardFormatInput'
import Button from 'src/components/basic/Button'
import { validateDateField } from 'src/utils/formDataManipulation'

interface TransactionItemFormProps {
  transaction: SecuritiesLawTransactionData;
  itemIndex: number;
  setTransaction: (data: Partial<SecuritiesLawTransactionData>) => void;
  removeTransaction: () => void;
  isDateIncorrect?: boolean;
}

const TransactionItemForm: FC<TransactionItemFormProps> = ({ transaction, itemIndex, setTransaction, removeTransaction, isDateIncorrect }) => {
  return (
    <ClaimItemFormMainContainer id="step0">
      <ClaimItemTitle>
        <h1>Transaction {itemIndex + 1}</h1>
        <hr />
      </ClaimItemTitle>
      <FlexDiv gap="18px" margin="48px 0 0 0">
        <LeftBar />
        <FlexDiv gap="56px" dir='column'>

          <ClaimItemFormSection maxWidth='80%'>
            <StepBullet>1</StepBullet>
            <FlexDiv dir='column' gap="16px">
              <FormInputTitle>Date</FormInputTitle>
              <FlexDiv maxWidth='440px'>
                <StandardFormatInput 
                  label=""
                  labelSize='high'
                  maskStyle='date'
                  value={transaction?.date ?? ''}
                  onValueChange={({ formattedValue }) => setTransaction({ date: formattedValue})}
                  isIncorrect={isDateIncorrect && !!validateDateField(transaction?.date)}
                  errorMessage={(isDateIncorrect && !!validateDateField(transaction?.date)) ? validateDateField(transaction?.date) : ''}
                />
              </FlexDiv>
            </FlexDiv>
          </ClaimItemFormSection>

          <ClaimItemFormSection maxWidth='80%'>
            <StepBullet>2</StepBullet>
            <FlexDiv dir='column' gap="16px">
              <FormInputTitle>Client name</FormInputTitle>
              <FlexDiv maxWidth='440px'>
                <StandardInput
                  label=""
                  value={transaction?.clientName ?? ''}
                  onChange={e => setTransaction({ clientName : e.target.value })}
                />
              </FlexDiv>
            </FlexDiv>
          </ClaimItemFormSection>

          <ClaimItemFormSection maxWidth='80%'>
            <StepBullet>3</StepBullet>
            <FlexDiv dir='column' gap="16px">
              <FormInputTitle>Size of offering</FormInputTitle>
              <FlexDiv maxWidth='440px'>
                <StandardInput
                  label=""
                  type='number'
                  value={transaction?.offeringSize ?? ''}
                  onChange={e => setTransaction({ offeringSize : e.target.value })}
                />
              </FlexDiv>
            </FlexDiv>
          </ClaimItemFormSection>

          <ClaimItemFormSection maxWidth='80%'>
            <StepBullet>4</StepBullet>
            <FlexDiv dir='column' gap="16px">
              <FormInputTitle>Role in transaction</FormInputTitle>
              <FlexDiv maxWidth='440px'>
                <StandardInput
                  label=""
                  value={transaction?.transactionRole ?? ''}
                  onChange={e => setTransaction({ transactionRole : e.target.value })}
                />
              </FlexDiv>
              {itemIndex > 0 ? (
                <FlexDiv margin="24px 0 0 0">
                  <Button variant='error' style={{padding: '5px 18px', fontSize: '14px'}} onClick={removeTransaction}>
                    Remove transaction
                  </Button>
                </FlexDiv>
              ) : null}
            </FlexDiv>
          </ClaimItemFormSection>
        </FlexDiv>
      </FlexDiv>
    </ClaimItemFormMainContainer>
  )
}

export default TransactionItemForm